export default __webpack_public_path__ + "static/media/afeef.a5ff210c.png";